/**
 * LA MARCA GERENCIAL / PERSONAL DE UN EGRESO (BAN-T2 lado panel; D-64 aclarado por Josse el 1-oct, #20860).
 *
 * Los pagos gerenciales o personales (casi siempre salidas chicas del banco) llevan una marca en el egreso. El panel la
 * muestra y SOLO el dueno la pone o la quita; el egreso baja al Desktop con la marca y alla solo lo ve el perfil
 * Propietario. No cambia el arqueo de caja.
 *
 * Contrato (nexo-api 394, 8b54b97): la LECTURA (GET businesses/{id}/egresos y /egresos/{id}) trae `marca_privada`
 * (snake: el DTO lleva JsonPropertyName); la ESCRITURA es PATCH /api/v1/auditoria/egresos/{id}/marca?businessId= con
 * {marcaPrivada} (camelCase). null = egreso normal.
 *
 * Puro: sin DOM. Lo mide scripts/check-marca-egreso.mjs.
 *
 * @module domain/marcaEgreso
 */

export const MARCAS = Object.freeze([
  Object.freeze({ valor: null,        texto: 'Normal',    color: '#8b949e' }),
  Object.freeze({ valor: 'gerencial', texto: 'Gerencial', color: '#d2a8ff' }),
  Object.freeze({ valor: 'personal',  texto: 'Personal',  color: '#f0883e' })
]);

/** La marca de un egreso tal como llega (tolera las dos formas). -> null | 'gerencial' | 'personal' */
export function leerMarca(egreso) {
  const v = egreso && typeof egreso === 'object' ? (egreso.marca_privada ?? egreso.marcaPrivada ?? null) : null;
  const t = typeof v === 'string' ? v.trim().toLowerCase() : '';
  return t === 'gerencial' || t === 'personal' ? t : null;
}

/** ¿La API de este ambiente ya sirve la marca? Si la lectura no trae la clave, todavia no: se dice y no se ofrece. */
export function apiTraeMarca(egreso) {
  return !!egreso && typeof egreso === 'object' && ('marca_privada' in egreso || 'marcaPrivada' in egreso);
}

/** El cuerpo del PATCH: solo la clave del contrato, en camelCase. */
export function cuerpoMarca(marca) {
  return { marcaPrivada: marca === 'gerencial' || marca === 'personal' ? marca : null };
}

/** Lo que se le dice al dueno despues de intentar marcar (por causa, sin codigos). */
export function mensajeMarca(res, marca) {
  if (res?.ok) {
    const m = MARCAS.find((x) => x.valor === (marca ?? null));
    return { ok: true, texto: marca ? `Marcado como ${m.texto.toLowerCase()}. Baja al Desktop con la marca; allá solo lo ve el perfil Propietario.` : 'Quitada la marca: vuelve a ser un egreso normal.' };
  }
  if (res?.code === 403 || res?.code === 'FORBIDDEN') return { ok: false, texto: 'Solo el dueño del negocio marca pagos gerenciales o personales.' };
  if (res?.code === 404) return { ok: false, texto: 'La API de este ambiente todavía no tiene la marca; en cuanto la publique, esto se enciende solo.' };
  return { ok: false, texto: 'No pudimos guardar la marca ahora. Intenta de nuevo en un momento.' };
}
